export default __webpack_public_path__ + "static/media/LocationBlue.e1760f0d.svg";